'use client';

import { DirectionProvider } from '@radix-ui/react-direction';
import { type ReactNode } from 'react';
import { getLangDir } from 'rtl-detect';

export const ReactDirectionProvider: React.FC<{ children: ReactNode; locale: string }> = ({ children, locale }) => {
  const direction = getLangDir(locale);

  return <DirectionProvider dir={direction}>{children}</DirectionProvider>;
};
